
window.__lazy_callback__ = function (lazyModule) {
  return class extends React.Component {
    state = {
      component: null,
    }
    componentWillMount() {
      lazyModule((module) => {
        if (typeof module.default === 'function') {
          this.setState({
            component: module.default,
          });
        } else {
          this.setState({
            component: module,
          });
        }
      });
    }
    render() {
      const Comp = this.state.component;
      return Comp ? <Comp {...this.props} /> : <div />;
    }
  };
}

import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { Route, Redirect } from 'react-router-dom'
import { getCookie, isChrome } from '../../assets/js/common'

class AuthRouter extends Component {
  render() {  
    const { component: Component } = this.props
    const IsChrome = isChrome()
    const utoken = getCookie('utoken') === null || getCookie('utoken') === '' ? false : true
    return (
      <Route render={props => {
        return IsChrome === true ? utoken ? <Component {...props} /> : <Redirect to="/" /> : <Redirect to="/chrome" />
      }} />
    )
  }
}

export default withRouter(AuthRouter);